import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  FormControlLabel,
  FormControl,
  Autocomplete,
  Button,
} from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import { Checkbox } from "@material-ui/core";
import { BackupTable, Delete } from "@material-ui/icons";
import moment from "moment";
import VendorCode from "../../NewInvoice/Dropdowns/VenderCode";
import UsersByRole from "../../NewInvoice/Dropdowns/UsersByRole";
import GL_Table from "../../NewInvoice/Tables/GL_Table";
import Vendor_Table from "../../NewInvoice/Tables/Vendor_Table";
import CommentHistory from "../../NewInvoice/Tables/CommentHistory";
import PODetail from "../../NewInvoice/Tables/PoDetail_Table";
import {
  deleteAttachment,
  getRefrenceDataList,
  uploadAdditioalDocumentFile,
  uploadFile,
  uploadFile_v1,
  getAllUsers,
} from "../../actions";
import { demandType, category, invoiceType } from "../../../Home/constant";
import { dashboardStyle } from "./style.js";
import { Download } from "@material-ui/icons";
import downloadAttachments from "../../../../Functions/downloadAttachments";
import { formatDateTimeForBackend } from "../../../../Functions";
import isAboveToday from "../../../../Functions/isAboveToday";
import isOldDateValidate from "../../../../Functions/isOldDateValidate.js";
import WarningBox from "../WarningBox";
import isFutureDate from "../../../../Functions/isFutureDate";
import POAlertDialog from "../../NewInvoice/Tables/PoTableAlert";
import getParameterByName from "../../../../Functions/functions";
import jwt from "jsonwebtoken";
import Tooltip  from "@mui/material/Tooltip";
const token = localStorage.getItem("user_token");

const user = jwt.decode(token);
const useStyles = makeStyles(dashboardStyle);

const spanStyle = {
  color: "#999",
  fontSize: "14px",
  cursor: "default",
};
const InvoiceDetailTextField = ({
  formState,
  newFormState,
  setNewFormState,
  selectedRole,
  disabled,
  poBasedState,
  showVendorAndPO_NumberForImport,
  showVendorCodeForImport,
  invoice_attachmentRef,
  additionalAttachmentRef,
  setAttachInvoiceLoading,
  // setAttchmentFile_UI,
  // attachmentFile_UI,
  physicalOrEInvoice,
  changeHandler,
  alignForAttachment,
  showAttachmentsHandler,
  attachmentURLList,
  setAttachmentURL,
  setAttachmentURLList,
  dNInvoicesorITNInvoices,
  edit,
  fields,
  setOpenInvalidWarningDate,
  multipleData,
  invoicePayload,
}) => {
  const classes = useStyles();
  const roleName = getParameterByName("roleName"); // get role name for show attachment
  const invoiceEdit = getParameterByName("edit"); // get form url

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [attachError, setAttachError] = useState("");
  const [docError, setDocError] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);

  const deleteAttachmentFunc = () => {
    deleteAttachment(
      setNewFormState,
      setAttachmentURLList,
      setOpenWarningBox,
      newFormState,
      attachmentURLList,
      currentStateForDeleteion,
      setdeleteLoader
    );
    // let ss = currentStateForDeleteion?.ss;
    // let f = currentStateForDeleteion?.f;
    // const files = newFormState?.additionalDocIds.filter((x, i) => {
    //   const n = x?.path.split("\\");
    //   const nn = n[n.length - 1];
    //   return nn !== ss;
    // });
    // setNewFormState((newFormState) => ({
    //   ...newFormState,
    //   additionalDocIds: files,
    // }));

    //
    // //removing data from attachemt list for preview
    // let filtered_attachs = attachmentURLList?.filter((x) => x !== f);
    // setAttachmentURLList(filtered_attachs);
    // setAttachmentURL(filtered_attachs[filtered_attachs.length - 1]);
    // setOpenWarningBox(false);
  };
  const [warningFlag, setWarningFlag] = useState(false);

  const deleteInvoice = () => {
    const data = {
      Id: newFormState?.invoice_attachment?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(function (item) {
          return ![newFormState?.invoice_attachment?.path].includes(item);
        });

        const filteredAttachmentsSR = newFormState?.attachment_Sr.filter(
          (x) => x !== newFormState?.invoice_attachment?.id
        );
        setAttachmentURLList(final);
        setNewFormState((formState) => ({
          ...formState,
          invoice_attachment: "",
          attachment_Sr: filteredAttachmentsSR,
        }));
        invoice_attachmentRef.current.value = null;
        setOpenWarningBox(false);
        setdeleteLoader(false);
        // setSuccessMessage(response.data);
      })
      .catch(function (error) {
        // setErrorMessage(error.response.data);
      });
  };





  useEffect(() => {
    getAllUsers(setUserData, setLoading);
  }, []);

  const isContainEmailFormate = (fileExtension) => {
    const emailExtensions = [
      "eml",
      "msg",
      "pst",
      "mbox",
      "emlx",
      "dbx",
      "mbx",
      "nws",
      "p7m",
      "mht",
      "mhtml",
      "rar",
      "zip",
    ];
    return emailExtensions.includes(fileExtension.toLowerCase());
  };

  const getVendorDisplayName = () => {
    const parts = newFormState?.vendor_Name?.split("-");
    if (parts?.length > 1) {
      // get 1st part with code
      const code = parts[0]?.trim();
      // const name = parts[1]?.trim();
      // If there is a dash, take the part after the first dash and trim any extra spaces
      const name = parts[1]?.trim();
      const Designation=parts[2]?.trim();
      const Department=parts[3]?.trim();
      return { code, name,Designation,Department };
    } else {
      // If there is no dash, return the original name
      // return newFormState?.vendor_Name?.trim();
      return { code: "", name: newFormState?.vendor_Name?.trim() };
    }
  };

  // Inside your component...

  const vendorDetails = getVendorDisplayName();
  return (
    <Grid container direction={"row"} spacing={2} style={{ marginTop: "2px" }}>
      {(showVendorCodeForImport() ||
        // (selectedRole !== "Logistic" && poBasedState == "Non-PO") ||\
        (selectedRole === "Department Coordinator" &&
          poBasedState === "Non-PO" &&
          !newFormState?.isPCDV) ||
        (selectedRole === "Import" && poBasedState === "Non-PO") ||
        (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
        (selectedRole === "Loam Approver" && poBasedState == "Non-PO") ||
        (newFormState?.isImport && poBasedState == "Non-PO") ||
        (selectedRole === "IP" &&
          poBasedState == "Non-PO" &&
          disabled &&
          !newFormState.isHR)) && (
        <>
          {/* vendor code */}
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Vendor Code:{`  `}
                {/* <span style={spanStyle}>{newFormState?.vendor_Name}</span> */}
                <span style={spanStyle}>{vendorDetails?.code}</span>
              </Typography>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Vendor Name:{`  `}
                {/* <span style={spanStyle}>{newFormState?.vendor_Name}</span> */}
                <span style={spanStyle}>{vendorDetails?.name}</span>
              </Typography>
            </FormControl>
          </Grid>
        </>
      )}
        {(showVendorCodeForImport() ||
        // (selectedRole !== "Logistic" && poBasedState == "Non-PO") ||\
        (selectedRole === "Department Coordinator" &&
          poBasedState === "Non-PO" &&
          !newFormState?.isPCDV) ||
        (selectedRole === "Import" && poBasedState === "Non-PO") ||
        (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
        (selectedRole === "Loam Approver" && poBasedState == "Non-PO") ||
        (newFormState?.isImport && poBasedState == "Non-PO") ||
        (selectedRole === "IP" &&
          poBasedState == "Non-PO" &&
          disabled &&
          !newFormState.isHR) ) && (
        <>
        {
           (vendorDetails?.Designation!==undefined && vendorDetails?.Designation!==null && vendorDetails?.Designation!=="") && 
          (vendorDetails?.Department!==undefined && vendorDetails?.Department!==null && vendorDetails?.Department!=="") &&
          (newFormState?.invoice_Type === "ERF" || newFormState?.invoice_Type === "MRF" || newFormState?.invoice_Type === "ARF" || newFormState?.invoice_Type === "FER")
          && (
         <>
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Employee Designation:{`  `}
                {/* <span style={spanStyle}>{newFormState?.vendor_Name}</span> */}
                <span style={spanStyle}>{vendorDetails?.Designation}</span>
              </Typography>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Employee Department:{`  `}
                {/* <span style={spanStyle}>{newFormState?.vendor_Name}</span> */}
                <span style={spanStyle}>{vendorDetails?.Department}</span>
              </Typography>
            </FormControl>
          </Grid>
         </>
          )
}
        </>
      )}
      {selectedRole === "Logistic" ||
      showVendorAndPO_NumberForImport() ||
      ((selectedRole === "TaxTeam" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "IR" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Import" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && fields) ||
        (selectedRole === "IP" && !edit && disabled) ||
        (selectedRole === "IP" && newFormState?.isVPPayment && !disabled)) &&
        poBasedState === "PO") ? (
        <>
          {/* Vendor */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Vendor Code : <span style={spanStyle}>{vendorDetails?.code}</span>
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Vendor Name : <span style={spanStyle}>{vendorDetails?.name}</span>
            </Typography>
          </Grid>
        </>
      ) : (
        ""
      )}
      {(selectedRole === "Import" ||
        (selectedRole === "Loam Approver" && newFormState?.isImport) ||
        (selectedRole === "Department Coordinator" && newFormState?.isImport) ||
        (selectedRole === "IP" &&
          newFormState?.isImport &&
          disabled &&
          !edit)) && (
        <>
          {/* isPSID */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControlLabel
              style={{ color: "black" }}
              label="PSID"
              color="secondary"
              control={
                <Checkbox
                  color="secondary"
                  fontSize="small"
                  checked={newFormState?.isPSID}
                  name="isPSID"
                  disabled={true}
                  onChange={(event) => {
                    setNewFormState((newFormState) => ({
                      ...newFormState,
                      isPSID: event.target.checked,
                    }));
                  }}

                  // disabled={selectedRole === "Logistic"}
                />
              }
            />
          </Grid>
          {/* PSID */}

          {newFormState?.isPSID && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                PSID:{` `}
                <span style={spanStyle}>{newFormState?.psid}</span>
              </Typography>
            </Grid>
          )}

          {/* Demand type */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Demand type:{` `}
                <span style={spanStyle}>{newFormState?.demandType || ""}</span>
              </Typography>
            </FormControl>
          </Grid>
        </>
      )}

      {/*Efdv invoice below 2 field for reviewer isPCDV  */}
      {newFormState?.isPCDV && !edit && disabled && (
        <>
          {/* PCDV Segment */}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              PCDV Segment:{` `}
              <span style={spanStyle}>{newFormState?.pcdvSegment || ""}</span>
            </Typography>
          </Grid>

          {/* PCDV Loacation */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              PCDV Loacation:{` `}
              <span style={spanStyle}>{newFormState?.pcdvLocation || ""}</span>
            </Typography>
          </Grid>
        </>
      )}
      {newFormState?.isHR && selectedRole === "IP" && disabled ? (
        <Grid
          item
          xs={12}
          sm={12}
          md={alignForAttachment ? 6 : 3}
          lg={alignForAttachment ? 6 : 3}
        >
          <FormControl fullWidth size="small">
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Category:{` `}
              <span style={spanStyle}>{newFormState?.invoiceCategory}</span>
            </Typography>

            {/* <Select
              size="small"
              // labelId="demo-simple-select-label"
              value={newFormState?.invoiceCategory}
              id="demo-simple-select"
              name="invoiceCategory"
              onChange={changeHandler}
              inputProps={{ "aria-label": "Without label" }}
              displayEmpty
              className={classes.selectEmpty}
              disabled={disabled}
            >
              <MenuItem value="" disabled>
                Select a Value
              </MenuItem>
              {category.map((item) => {
                return <MenuItem value={item.role}>{item.role}</MenuItem>;
              })}
            </Select>*/}
          </FormControl>
        </Grid>
      ) : null}

      {/* Invoice Type */}
      {selectedRole === "Import" ||
      (selectedRole === "Loam Approver" &&
        poBasedState === "Non-PO" &&
        !newFormState?.isPCDV) ||
      (selectedRole === "Department Coordinator" &&
        poBasedState === "Non-PO" &&
        !newFormState?.isPCDV) ||
      (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
      // (selectedRole === "IP" &&

      //   !edit &&
      //   disabled) ||
      (selectedRole === "Buyer" && poBasedState === "Non-PO") ||
      (selectedRole === "IP" &&
        disabled &&
        !edit &&
        !newFormState.isHR &&
        (newFormState?.isImport ||
          (!newFormState?.pO_Based && !newFormState?.isPCDV))) ||
      (selectedRole === "IR" && poBasedState === "Non-PO") ? (
        <Grid
          item
          xs={12}
          sm={6}
          md={alignForAttachment ? 6 : 3}
          lg={alignForAttachment ? 6 : 3}
        >
          <FormControl fullWidth size="small">
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Type:{`  `}
              <span style={spanStyle}>
                {newFormState?.invoice_Type || newFormState?.invoice_Type}
              </span>
            </Typography>
          </FormControl>
        </Grid>
      ) : (
        ""
      )}
      {(selectedRole === "IR" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Logistic" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && !edit) ||
        (selectedRole === "IP" && fields)) && (
        <>
          {/* Invoice Number */}
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              {newFormState?.isHR ? "Reference Number: " : "Invoice Number: "}

              <span style={spanStyle}>{newFormState?.invoice_No}</span>
            </Typography>
          </Grid>
          {/* Invoice Date */}
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
            style={{ paddingRight: "18px" }}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Date:{`  `}
              <span style={spanStyle}>
                {moment(newFormState?.invoice_Date).format("DD-MM-YYYY")}
              </span>
            </Typography>
          </Grid>
          {/* Invoice Amount */}
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Amount:{" "}
              <span style={spanStyle} className={classes.asterisk}>
                {Number(newFormState?.invoice_Amount)?.toLocaleString()}
              </span>
            </Typography>
          </Grid>
          {/* Invoice Description */}
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Description:
              {`  `}
              <span style={spanStyle}> {newFormState?.invoice_Desc} </span>
            </Typography>
          </Grid>
        </>
      )}
      {/* ---------------- */}
      {/*vendoe code  */}

      {/* Document type */}
      {
        // (selectedRole === "IP" && newFormState?.isImport && disabled && !edit) ||
        !newFormState?.pO_Based &&
        selectedRole === "IP" &&
        // poBasedState === "Non-PO" &&
        !edit &&
        !disabled ? (
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Document Type:{` `}
                <span style={{ spanStyle }}>
                  {newFormState?.document_Type || newFormState?.document_Type}
                </span>
              </Typography>
            </FormControl>
          </Grid>
        ) : (
          ""
        )
      }

      {(selectedRole === "HR" || selectedRole === "Line Manager") && (
        <>
          {/* Category */}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth size="small">
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Category:{` `}
                <span style={spanStyle}>{newFormState?.invoiceCategory}</span>
              </Typography>
            </FormControl>
          </Grid>

          {/* Reference */}
          <Grid item xs={12} sm={6} md={6} lg={6}>
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Reference Number:{` `}
              <span style={spanStyle}>{newFormState?.invoice_No}</span>
            </Typography>
          </Grid>
          {/* Invoice Amount */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Amount:{" "}
              <span style={spanStyle} className={classes.asterisk}>
                {Number(newFormState?.invoice_Amount)?.toLocaleString()}
              </span>
            </Typography>
          </Grid>
          {/* Description */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Description:{` `}
              <span style={spanStyle}>{newFormState?.invoice_Desc}</span>
            </Typography>
            {/* <TextField
              fullWidth
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              value={newFormState?.invoice_Desc}
              onChange={changeHandler}
              id="outlined-basic"
              variant="outlined"
              disabled={disabled}
            />*/}
          </Grid>
          {/* Date */}
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{ paddingRight: "18px" }}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Date:{` `}
              <span style={spanStyle}>{newFormState?.invoice_Date || ""}</span>
            </Typography>
          </Grid>
          {(newFormState?.invoiceCategory === "Final Settlement – Norma" ||
            newFormState?.invoiceCategory ===
              "Final Settlement – Death cas") && (
            <>
              {/* FS DOC Date */}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{ paddingRight: "18px" }}
              >
                <Typography
                  variant="h5"
                  style={{ color: "black", fontStyle: "bold" }}
                >
                  FS DOC Date:{" "}
                  <span style={spanStyle}>
                    {newFormState?.fsDocumentDate || ""}
                  </span>
                </Typography>
                {/*<input
                  className={classes.inputField}
                  name="fsDocumentDate"
                  type="date"
                  max="9999-12-31"
                  onChange={changeHandler}
                  value={newFormState?.fsDocumentDate || ""}
                  disabled={disabled}
                  onInput={(newValue) => {
                    setNewFormState((formState) => ({
                      ...formState,
                      fsDocumentDate: formatDateTimeForBackend(newValue),
                    }));
                  }}
                />*/}

                {/*  <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // value={value}
                    // onChange={(newValue) => {
                    //   setValue(newValue);
                    // }}
                    value=" "
                    error={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={changeHandler}
                        value={newFormState?.fs_Doc_Date || ""}
                        {...params}
                        error={false}
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                      />
                    )}
                  />
                      </LocalizationProvider>*/}
              </Grid>

              {/* Final Settlement Doc */}
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography
                  variant="h5"
                  style={{ color: "black", fontStyle: "bold" }}
                >
                  Final Settlement Doc:{" "}
                  <span style={spanStyle}>
                    {newFormState?.fsDocumentNumber}
                  </span>
                </Typography>
                {/* <TextField
                  fullWidth
                  size="small"
                  name="fsDocumentNumber"
                  value={newFormState?.fsDocumentNumber}
                  onChange={changeHandler}
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  disabled={disabled}
                />*/}
              </Grid>
            </>
          )}
        </>
      )}

      {/* {(selectedRole === "IR" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "HR" ||
        selectedRole === "Line Manager" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Logistic" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && fields) ||
        (selectedRole === "IP" && !edit)) && (
        <>
          
          <Grid
            item
            xs={12}
            sm={6}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Invoice Amount:{" "}
              <span style={spanStyle} className={classes.asterisk}>
                {newFormState?.invoice_Amount}
              </span>
            </Typography>
          </Grid>
        </>
      )} */}
      {/* {((selectedRole === "IP" && !disabled && !edit) || fields) && ( */}
      {((selectedRole === "IP" && !disabled && !edit) ||
        (selectedRole === "IP" && fields)) && (
        <>
          {/* Posting Date */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
            style={{ paddingRight: "18px" }}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Posting Date:
            </Typography>

            {/*  <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                shouldDisableDate={isAboveToday}
                // value={value}
                onChange={(newValue) => {
                  isOldDateValidate(
                    formatDateTimeForBackend(newValue),
                    setOpenInvalidWarningDate,
                    setNewFormState
                  );
                  setNewFormState((formState) => ({
                    ...formState,
                    posting_Date: formatDateTimeForBackend(newValue),
                  }));
                  isFutureDate(
                    formatDateTimeForBackend(newValue),
                    setNewFormState,
                    "posting_Date"
                  );
                }}
                disabled={disabled || edit}
                value={newFormState?.posting_Date}
                error={false}
                renderInput={(params) => (
                  <TextField
                    fullWidth
                    size="small"
                    name="posting_Date"
                    id="outlined-basic"
                    label="Outlined"
                    variant="outlined"
                    onChange={changeHandler}
                    required
                    {...params}
                    error={false}
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
                  */}
            <input
              className={classes.inputField}
              name="posting_Date"
              type="date"
              max="9999-12-31"
              disabled={disabled}
              style={{
                color: disabled ? "#B4B4B4" : null,
                backgroundColor: disabled ? "white" : null,
              }}
              onChange={changeHandler}
              onInput={(newValue) => {
                isOldDateValidate(
                  formatDateTimeForBackend(newValue),
                  setOpenInvalidWarningDate
                  // setNewFormState
                );
                setNewFormState((formState) => ({
                  ...formState,
                  posting_Date: formatDateTimeForBackend(newValue),
                }));
                isFutureDate(
                  formatDateTimeForBackend(newValue),
                  setNewFormState,
                  "posting_Date"
                );
              }}
              value={newFormState?.posting_Date}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Currency:
            </Typography>
            <Autocomplete
              id="submitter_role"
              options={multipleData?.currency || []}
              defaultValue={[multipleData?.currency[0]]}
              size="small"
              disabled={disabled || edit}
              value={{
                ReferenceCode:
                  newFormState?.currency || newFormState?.Currency || "",
              }}
              // value={formState.invoice_Payment}
              getOptionLabel={(option) =>
                (option !== "" && `${option?.ReferenceCode}`) || ""
              }
              // loading={rolesLoading}
              onChange={(event, newValue) => {
                const e = {
                  target: {
                    name: "currency",
                    value: newValue?.ReferenceCode,
                  },
                };

                changeHandler(e);
              }}
              renderInput={(params) => (
                <TextField {...params} type="text" name="" label="" required />
              )}
            />
          </Grid>
        </>
      )}
      {selectedRole === "IP" && !edit && !disabled && !newFormState?.isPCDV && (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Attach Invoice:
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              // required={newFormState?.invoice_attachment?.path === ""}
              disabled={disabled}
              // onChange={() => }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <input
                      ref={invoice_attachmentRef}
                      type="file"
                      accept=".png, .jpg, .jpeg, .pdf"
                      name="invoice_attachment"
                      onChange={(e) =>
                        // uploadFile(
                        //   e,
                        //   setNewFormState,
                        //   setAttachInvoiceLoading,
                        //   "invoice_attachment",
                        //    setAttchmentFile_UI
                        //   () => {},
                        //   () => {},
                        //   () => {},
                        //   setAttachError
                        // )
                        uploadFile_v1(
                          e,
                          setNewFormState,
                          setAttachInvoiceLoading,
                          "invoice_attachment",
                          setAttchmentFile_UI,
                          invoice_attachmentRef,
                          setAttachmentURLList,
                          setAttachmentURL,
                          attachmentURLList,
                          newFormState?.invoice_attachment,
                          setDocError,
                          setAttachError,
                          setAlertMessage,
                          invoicePayload,
                          { roleName: selectedRole },
                          false,
                          () => {},
                          () => {}
                        )
                      }
                      disabled={disabled}
                      style={{ width: "209px" }}
                    />
                  </InputAdornment>
                ),
              }}
              FormHelperTextProps={{
                className: classes.helperText,
              }}
              // error={attachError ? true : false}
              // helperText={attachError ? `${attachError}` : null}
            />
            {newFormState?.invoice_attachment && (
              <>
                <IconButton
                  size="small"
                  onClick={() => {
                    downloadAttachments(newFormState?.invoice_attachment?.path);
                  }}
                >
                  <Download color="secondary" />{" "}
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => {
                    setWarningFlag(false);
                    setOpenWarningBox(true);
                  }}
                >
                  <Delete
                    titleAccess="Delete"
                    color="danger"
                    fontSize="small"
                    style={{
                      color:
                        // disable ||
                        newFormState?.invoice_attachment?.role_Name !==
                        selectedRole
                          ? "gray"
                          : "",
                    }}
                  />{" "}
                </IconButton>
                <>
                  <IconButton
                    style={{
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      const allowedExtensions = [
                        ".png",
                        ".pdf",
                        ".jpg",
                        ".jpeg",
                        ".PNG",
                        ".JPG",
                        ".JPEG",
                        ".PNG",
                        ".PDF",
                      ];
                      const fileExtension =
                        "." +
                        newFormState?.invoice_attachment?.path
                          ?.split("\\")
                          [
                            newFormState?.invoice_attachment?.path?.split("\\")
                              .length - 1
                          ].split(".")
                          .pop();
                      if (allowedExtensions.includes(fileExtension)) {
                        showAttachmentsHandler(
                          newFormState?.invoice_attachment
                        );
                      } else {
                        showAttachmentsHandler(
                          newFormState?.invoice_attachment
                        );
                        window.open(
                          `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                          "_blank"
                        );
                      }
                    }}
                    s
                  >
                    <span style={{ fontSize: "14px" }}>
                      {
                        newFormState?.invoice_attachment?.path?.split("\\")[
                          newFormState?.invoice_attachment?.path?.split("\\")
                            .length - 1
                        ]
                      }
                    </span>
                  </IconButton>
                </>
              </>
            )}
          </Grid>
        </>
      )}
      {(selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "IR" ||
        selectedRole === "HR" ||
        selectedRole === "Line Manager" ||
        selectedRole === "EFDV Initiator" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Logistic" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && invoiceEdit === "true")) && (
        <>
          {/* Additional Document */}
          {!disabled && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Additional Document:
                {/*  */}
              </Typography>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={additionalAttachmentRef}
                        type="file"
                        // accept="application/pdf, image/png , image/jpg , image/jpeg "
                        name="additionalDocIds"
                        disabled={disabled}
                        onChange={(e) =>
                          uploadAdditioalDocumentFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "additionalDocIds",
                            additionalAttachmentRef,
                            setDocError,
                            setAttachError,
                            setAlertMessage,
                            invoicePayload,
                            { roleName: selectedRole },
                            false,
                            () => {},
                            () => {}
                          )
                        }
                        style={{ width: "209px" }}
                        multiple
                      />
                    </InputAdornment>
                  ),
                }}
                // FormHelperTextProps={{
                //   className: classes.helperText,
                // }}
                // error={docError ? true : false}
                // helperText={docError ? `${docError}` : null}
              />
              {newFormState?.additionalDocIds.length > 0 &&
                newFormState?.additionalDocIds.map((f, index) => {
                  const s = f?.path?.split("\\");
                  const ss = s[s.length - 1];
                  return (
                    <div>
                      {f?.path !== "" ? (
                        <>
                          {/* {!disabled && (
                        <Delete
                          color="danger"
                          style={{
                            cursor: "pointer",
                          }}
                          fontSize="small"
                          onClick={() => {
                            setOpenWarningBox(true);

                            setCurrentStateForDeleteion({
                              ss,
                              f,
                            });
                          }}
                        />
                      )} */}
                          <IconButton
                            size="small"
                            disabled={f?.role_Name !== selectedRole}
                            onClick={() => {
                              setCurrentStateForDeleteion(f);
                              setOpenWarningBox(true);
                              setWarningFlag(true);
                            }}
                          >
                            <Delete
                              titleAccess="Delete"
                              color="danger"
                              fontSize="small"
                              style={{
                                color:
                                  // disable ||
                                  f?.role_Name !== selectedRole ? "gray" : "",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => {
                              downloadAttachments(f?.path);
                            }}
                          >
                            <Download color="secondary" />{" "}
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const extension = f.path
                                ?.match(/\.[^.]+$/)[0]
                                .substring(1);
                              const allowedExtensions = [
                                ".png",
                                ".pdf",
                                ".jpg",
                                ".jpeg",
                                ".PNG",
                                ".JPG",
                                ".JPEG",
                                ".PNG",
                                ".PDF",
                              ];
                              const fileExtension = "." + ss.split(".").pop();
                              if (allowedExtensions.includes(fileExtension)) {
                                setAttachmentURL(f);
                              } else {
                                if (isContainEmailFormate(extension)) {
                                  downloadAttachments(f.path);
                                } else {
                                  setAttachmentURL(f);

                                  window.open(
                                    `${process.env.REACT_APP_API_URL}/${f.path}`,
                                    "_blank"
                                  );
                                }
                              }
                            }}
                          >
                            <span style={{ fontSize: "12px" }}>{ss}</span>
                          </IconButton>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
            </Grid>
          )}
        </>
      )}
      {(selectedRole === "IR" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Import" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && fields && !newFormState?.isHR) ||
        (selectedRole === "IP" && !edit && !newFormState?.isHR)) && (
        <>
          {/* PO Number */}
          {((selectedRole === "IR" ||
            (selectedRole === "IP" && disabled) ||
            (selectedRole === "Loam Approver" && !newFormState?.isPCDV) ||
            selectedRole === "Buyer" ||
            selectedRole === "TaxTeam" ||
            selectedRole === "I2P Initiator") &&
            (poBasedState === "PO" || newFormState?.pO_Based)) ||
          showVendorAndPO_NumberForImport() ? (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 3}
                lg={alignForAttachment ? 6 : 3}
              >
                <Typography
                  variant="h5"
                  style={{ color: "black", fontStyle: "bold" }}
                >
                  PO Number:{" "}
                  <span style={spanStyle}>{newFormState?.pO_No}</span>
                </Typography>
              </Grid>
              {( formState?.po_Date !== "" ) && 
              <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
<Typography
variant="h5"
style={{ color: "black", fontStyle: "bold" }}
>
PO Date:{" "}
<span style={spanStyle}>
 {
  formState?.po_Date
 }
</span>
</Typography>
</Grid>
}
            </>
          ) : (
            ""
          )}
        </>
      )}
      {/* {selectedRole === "IP" && */}
      {/* // poBasedState === "Non-PO" &&
        // !newFormState?.isPCDV && */}
      {/* !edit &&
        disabled && (
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              Days To Sales Tax Lapse{" "} */}
      {/**/}
      {/* </Typography>
            <TextField
              fullWidth
              name=""
              type="number"
              value={newFormState?.daysto_sale_taxlapse || ""}
              onChange={changeHandler}
              disabled={disabled}
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
            />
          </Grid>
        )} */}
      {((selectedRole === "Department Coordinator" &&
        poBasedState === "Non-PO" &&
        !newFormState?.isPCDV) ||
        (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
        selectedRole === "TaxTeam" ||
        newFormState?.invoice_Type === "DN" ||
        (selectedRole === "IP" &&
          newFormState?.invoice_Type !== "ERF" &&
          // poBasedState === "Non-PO" &&
          !newFormState?.isPCDV &&

          !edit &&
          disabled) ||
        selectedRole === "Logistic" ||
        (selectedRole === "Loam Approver" && poBasedState === "Non-PO")) && (
        // !newFormState?.isPCDV
        <>
          {(newFormState?.invoice_Type !== "DES" || user?.Location !== "1") && (
            <Grid
              item
              xs={12}
              sm={6}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Days To Sales Tax Lapse:{" "}
                <span style={spanStyle}>
                  {newFormState?.daysto_sale_taxlapse}
                </span>
              </Typography>
            </Grid>        
          )}

<Grid
              item
              xs={12}
              sm={6}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Due Date:{" "}
                <span style={spanStyle}>
                {moment(formState?.due_Date).format("DD-MM-YYYY")}
                </span>
              </Typography>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Payment Terms:{" "}
                <span style={spanStyle}>
                {formState?.paymentTerm}
                </span>
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
<Typography
variant="h5"
style={{ color: "black", fontStyle: "bold" }}
>
Plant Code:{" "}
<span style={spanStyle}>
 {
  formState?.plant_Code
 }
</span>
</Typography>
</Grid>  

          {/* {!newFormState?.isHR && user?.Location !== "1" ? (
            <Grid
              item
              xs={12}
              sm={6}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Courier Tracking #:{" "}
                <span style={spanStyle}>
                  {Number(newFormState?.courier_Tracking_No)}
                </span>
              </Typography>
            </Grid>
          ) : null} */}
        </>
      )}

      {(((selectedRole === "IR" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "TaxTeam" ||
        (selectedRole === "IP" && newFormState?.dept_coordinator) ||
        (selectedRole === "Loam Approver" && !newFormState.isImport) ||
        selectedRole === "Department Coordinator") &&
        poBasedState === "Non-PO") ||
        selectedRole === "EFDV Initiator") && (
        <>
          {/* Department Coordinator */}

          {!newFormState?.isImport &&
            !newFormState?.isVPPayment &&
            !edit &&
            disabled && (
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 3}
                lg={alignForAttachment ? 6 : 3}
              >
                <Typography
                  variant="h5"
                  style={{ color: "black", fontStyle: "bold" }}
                >
                  Department Coordinator:{` `}
                  {userData
                    ?.filter((item) => {
                      return item?.userId === newFormState?.dept_coordinator;
                    })
                    ?.map((val) => (
                      <span style={spanStyle}>{val?.username}</span>
                    ))}
                </Typography>
                {/*  <FormControl fullWidth size="small">
                  <UsersByRole
                    label="Department Coordinator"
                    apiString="Department Coordinator"
                    name="dept_coordinator"
                    formState={newFormState}
                    changeHandler={changeHandler}
                    required={true}
                    disabled={disabled}
                    classes={classes}
                  />
                </FormControl>*/}
              </Grid>
            )}
        </>
      )}
      {(selectedRole === "IR" ||
        selectedRole === "Logistic" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Import" ||
        (selectedRole === "IP" && disabled)) && (
        <>
          {/* Bar code */}
          {newFormState?.isPCDV && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography
                variant="h5"
                style={{ color: "black", fontStyle: "bold" }}
              >
                Bar code:{" "}
                <span style={spanStyle}>{newFormState?.barcode_No}</span>
              </Typography>
            </Grid>
          )}

          {/* IP user */}
          {!newFormState?.isPCDV &&
            selectedRole !== "IP" &&
            selectedRole !== "Loam Approver" &&
            disabled && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={alignForAttachment ? 6 : 3}
                  lg={alignForAttachment ? 6 : 3}
                >
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    IP User:{` `}
                    {userData
                      ?.filter((item) => {
                        return item.userId === newFormState?.ipUser;
                      })
                      ?.map((val) => (
                        <span style={spanStyle}>{val.username}</span>
                      ))}
                  </Typography>

                  {/*
                <FormControl fullWidth size="small">
                    <UsersByRole
                      label="IP User"
                      placehold="IP User"
                      apiString="IP"
                      name="ipUser"
                      formState={newFormState}
                      changeHandler={changeHandler}
                      required={true}
                      disabled={disabled}
                      classes={classes}
                    />
                </FormControl>
              */}
                </Grid>
                {/* Tax Team */}
                {!newFormState?.skipTaxStep && !newFormState?.isVppayment && (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={alignForAttachment ? 6 : 3}
                    lg={alignForAttachment ? 6 : 3}
                  >
                    <Typography
                      variant="h5"
                      style={{ color: "black", fontStyle: "bold" }}
                    >
                      Tax Team:{` `}
                      {userData
                        ?.filter((item) => {
                          return item.userId === newFormState?.taxTeam;
                        })
                        ?.map((val) => (
                          <span style={spanStyle}>{val.username}</span>
                        ))}
                    </Typography>
                    {/*  <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Tax Team"
                        apiString="Tax Team"
                        name="taxTeam"
                        formState={newFormState}
                        changeHandler={changeHandler}
                        required={true}
                        classes={classes}
                        disabled={disabled}
                      />
                    </FormControl>*/}
                  </Grid>
                )}
              </>
            )}
        </>
      )}

      {(selectedRole === "I2P Initiator" ||
        selectedRole === "IR" ||
        (selectedRole === "IP" &&
          disabled &&
          !newFormState?.isImport &&
          !newFormState?.isHR) ||
        (selectedRole === "Buyer" && disabled)) && (
        <>
          {/* GRN Number */}
          {poBasedState == "PO" && (
            <>
              {newFormState?.grn_No !== "" && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={alignForAttachment ? 6 : 3}
                  lg={alignForAttachment ? 6 : 3}
                >
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    GRN Number:{` `}
                    <span style={spanStyle}>{newFormState?.grn_No}</span>
                  </Typography>
                  {/* <TextField
                    fullWidth
                    size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    name="grn_No"
                    disabled={disabled}
                    value={newFormState?.grn_No}
                    onChange={changeHandler}
                  />*/}
                </Grid>
              )}
              {newFormState?.delv_Note_No !== "" && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={alignForAttachment ? 6 : 3}
                  lg={alignForAttachment ? 6 : 3}
                >
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    DN Number:{` `}
                    <span style={spanStyle}>
                      {newFormState?.delv_Note_No || ""}
                    </span>
                  </Typography>
                  {/* <TextField
                    fullWidth
                    size="small"
                    sx={{
                      // width: "70%",
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    disabled={disabled}
                    name="delv_Note_No"
                    required={newFormState?.pO_No === "" ? true : false}
                    value={newFormState?.delv_Note_No || ""}
                    onChange={changeHandler}
                  />*/}
                </Grid>
              )}
            </>
          )}

          {/* IR user */}
          {selectedRole === "IP" && !disabled ? (
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <FormControl fullWidth size="small">
                <UsersByRole
                  label="IR User"
                  apiString="IR"
                  name="irUser"
                  formState={newFormState}
                  changeHandler={changeHandler}
                  required={true}
                  classes={classes}
                />
              </FormControl>
            </Grid>
          ) : (
            ""
          )}
        </>
      )}

      {selectedRole === "Logistic" ? (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Logistic Team:{` `}
              {userData
                ?.filter((item) => {
                  return item.userId === newFormState?.logisticsTeam;
                })
                ?.map((val) => (
                  <span style={spanStyle}>{val.username}</span>
                ))}
            </Typography>
            {/*<FormControl fullWidth size="small">
              <UsersByRole
                label="Logistic Team"
                apiString="Logistic"
                name="logisticsTeam"
                formState={newFormState}
                changeHandler={changeHandler}
                required={true}
                classes={classes}
                disabled={disabled}
              />
                      </FormControl>*/}
          </Grid>
        </>
      ) : (
        ""
      )}

      {(selectedRole === "TaxTeam" || selectedRole === "Logistic") &&
        newFormState?.isLogistics &&
        (newFormState?.invoice_Type === "DN" ||
          newFormState?.invoice_Type === "ITN") && (
          <>
            {/* Shipment */}
            {
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 3}
                lg={alignForAttachment ? 6 : 3}
              >
                <Typography style={{ color: "black" }}>
                  {newFormState?.invoice_Type === "DN" ? "Shipment" : ""}{" "}
                  {newFormState?.invoice_Type === "ITN" ? "STO Number" : ""}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="pO_No"
                  required
                  disabled={disabled}
                  value={newFormState?.pO_No}
                  onChange={changeHandler}
                />
              </Grid>
            }
          </>
        )}

      {/* Attach Invoice */}

      {/*  {(selectedRole === "Import" ||
        selectedRole === "IR" ||
        selectedRole === "Logistic" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "I2P Initiator" ||
        (selectedRole === "IP" && !edit) ||
        (selectedRole === "Department Coordinator" && !newFormState?.isPCDV) ||
        selectedRole === "Buyer" ||
        (selectedRole === "Loam Approver" &&
          disabled &&
          !newFormState?.isPCDV)) && (
        <>
        {disabled && !newFormState?.isPCDV && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                Attach Invoice:
              </Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                // required={newFormState?.invoice_attachment?.path === ""}
                disabled={disabled}
                // onChange={() => }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={invoice_attachmentRef}
                        type="file"
                        accept=".png, .jpg, .jpeg, .pdf"
                        name="invoice_attachment"
                        onChange={(e) =>
                          uploadFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "invoice_attachment",
                            // setAttchmentFile_UI
                            () => {},
                            () => {},
                            () => {},
                            setAttachError
                          )
                        }
                        disabled={disabled}
                        style={{ width: "209px" }}
                      />
                    </InputAdornment>
                  ),
                }}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}
                // error={attachError ? true : false}
                // helperText={attachError ? `${attachError}` : null}
              />
              {newFormState?.invoice_attachment && (
                <>
                  {" "}
                  {!disabled ? (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setNewFormState((formState) => ({
                          ...newFormState,
                          invoice_attachment: {},
                        }));
                        invoice_attachmentRef.current.value = null;
                      }}
                    >
                      <Delete color="danger" fontSize="small" />

                      <span style={{ fontSize: "14px" }}>
                        {
                          newFormState?.invoice_attachment?.path?.split("\\")[
                            newFormState?.invoice_attachment?.path?.split("\\")
                              .length - 1
                          ]
                        }
                      </span>
                    </IconButton>
                  ) : (
                    <>
                      <Download
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          downloadAttachments(
                            newFormState?.invoice_attachment?.path
                          );
                        }}
                      />
                      <IconButton
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const allowedExtensions = [
                            ".png",
                            ".pdf",
                            ".jpg",
                            ".jpeg",
                            ".PNG",
                            ".JPG",
                            ".JPEG",
                            ".PNG",
                            ".PDF",
                          ];
                          const fileExtension =
                            "." +
                            newFormState?.invoice_attachment?.path
                              ?.split("\\")
                              [
                                newFormState?.invoice_attachment?.path?.split(
                                  "\\"
                                ).length - 1
                              ].split(".")
                              .pop();
                          if (allowedExtensions.includes(fileExtension)) {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                          } else {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                            window.open(
                              `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                              "_blank"
                            );
                          }
                        }}
                        s
                      >
                        <span style={{ fontSize: "14px" }}>
                          {
                            newFormState?.invoice_attachment?.path?.split("\\")[
                              newFormState?.invoice_attachment?.path?.split(
                                "\\"
                              ).length - 1
                            ]
                          }
                        </span>
                      </IconButton>
                    </>
                  )}
                </>
              )}
            </Grid>
           )}
           </>

                        )}
                      */}

      {(selectedRole === "HR" || selectedRole === "Line Manager") && (
        <>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography
              variant="h5"
              style={{ color: "black", fontStyle: "bold" }}
            >
              Line Manager:{` `}
              {userData
                ?.filter((item) => {
                  return item.userId === newFormState?.lineManager;
                })
                ?.map((val) => (
                  <span style={spanStyle}>{val.username}</span>
                ))}
            </Typography>
            {/* <UsersByRole
              label="Line Manager"
              apiString="Line Manager"
              name="lineManager"
              formState={newFormState}
              changeHandler={changeHandler}
              required={true}
              classes={classes}
              disabled={disabled}
            />*/}
          </Grid>
          {newFormState?.invoiceCategory !== "Employee Advance" &&
            newFormState?.invoiceCategory !== "Employee Loan" && (
              <>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    Shared Services:{` `}
                    {userData
                      ?.filter((item) => {
                        return item.userId === newFormState?.sharedServices;
                      })
                      ?.map((val) => (
                        <span style={spanStyle}>{val.username}</span>
                      ))}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Typography
                    variant="h5"
                    style={{ color: "black", fontStyle: "bold" }}
                  >
                    Director HR:{` `}
                    {userData
                      ?.filter((item) => {
                        return item.userId === newFormState?.directorHR;
                      })
                      ?.map((val) => (
                        <span style={spanStyle}>{val.username}</span>
                      ))}
                  </Typography>
                </Grid>
              </>
            )}
        </>
      )}
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          marginLeft: "0px",
        }}
      >
        {disabled && (
          <Typography
            variant="h5"
            style={{ color: "black", fontStyle: "bold" }}
          >
            Attachments:
          </Typography>
        )}
        {(selectedRole === "Import" ||
          selectedRole === "IR" ||
          selectedRole === "Logistic" ||
          selectedRole === "TaxTeam" ||
          selectedRole === "I2P Initiator" ||
          (selectedRole === "IP" && !edit) ||
          (selectedRole === "Department Coordinator" &&
            !newFormState?.isPCDV) ||
          selectedRole === "Line Manager" ||
          selectedRole === "Buyer" ||
          selectedRole === "View Only" ||
          (selectedRole === "Loam Approver" &&
            disabled &&
            !newFormState?.isPCDV)) && (
          <>
            {disabled && !newFormState?.isPCDV && (
              <>
                {newFormState?.invoice_attachment && (
                  <>
                    <IconButton
                      size="small"
                      onClick={() => {
                        downloadAttachments(
                          newFormState?.invoice_attachment?.path
                        );
                      }}
                    >
                      <Download color="secondary" />{" "}
                    </IconButton>
                    <a
              href={`${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`}
              target="_blank"
            >
              <Button
                // variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>
                    {/* <IconButton
                      size="small"
                      disabled={disabled}
                      onClick={() => {
                        setNewFormState((formState) => ({
                          ...newFormState,
                          invoice_attachment: {},
                        }));
                        invoice_attachmentRef.current.value = null;
                      }}
                    >
                      <Delete
                        titleAccess="Delete"
                        // color="danger"
                        fontSize="small"
                        style={{
                          color: disabled ? "gray" : "",
                        }}
                      />
                      </IconButton>*/}
                    <>
                      <IconButton
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const allowedExtensions = [
                            ".png",
                            ".pdf",
                            ".jpg",
                            ".jpeg",
                            ".PNG",
                            ".JPG",
                            ".JPEG",
                            ".PNG",
                            ".PDF",
                          ];
                          const fileExtension =
                            "." +
                            newFormState?.invoice_attachment?.path
                              ?.split("\\")
                              [
                                newFormState?.invoice_attachment?.path?.split(
                                  "\\"
                                ).length - 1
                              ].split(".")
                              .pop();
                          if (allowedExtensions.includes(fileExtension)) {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                          } else {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                            window.open(
                              `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                              "_blank"
                            );
                          }
                        }}
                        s
                      >
                        <span style={{ fontSize: "14px" }}>
                          {
                            newFormState?.invoice_attachment?.path?.split("\\")[
                              newFormState?.invoice_attachment?.path?.split(
                                "\\"
                              ).length - 1
                            ]
                          }
                        </span>
                      </IconButton>
                    </>
                  </>
                )}
              </>
            )}
          </>
        )}
        {(selectedRole === "Import" ||
          selectedRole === "I2P Initiator" ||
          selectedRole === "Department Coordinator" ||
          selectedRole === "Loam Approver" ||
          selectedRole === "IR" ||
          selectedRole === "HR" ||
          selectedRole === "Line Manager" ||
          selectedRole === "EFDV Initiator" ||
          selectedRole === "TaxTeam" ||
          selectedRole === "Logistic" ||
          selectedRole === "Buyer" ||
          selectedRole === "View Only" ||
          (selectedRole === "IP" && disabled)) && (
          <>
            {newFormState?.additionalDocIds?.length > 0 &&
              newFormState?.additionalDocIds?.map((f, index) => {
                const s = f?.path?.split("\\");
                const ss = s[s.length - 1];
                return (
                  <div>
                    {f?.path !== "" ? (
                      <>
                        {/* {!disabled && (
              <Delete
                color="danger"
                style={{
                  cursor: "pointer",
                }}
                fontSize="small"
                onClick={() => {
                  setOpenWarningBox(true);
  
                  setCurrentStateForDeleteion({
                    ss,
                    f,
                  });
                }}
              />
            )} */}
                        <IconButton
                          size="small"
                          onClick={() => {
                            downloadAttachments(f?.path);
                          }}
                        >
                          <Download color="secondary" />{" "}
                        </IconButton>
                        <a
              href={`${process.env.REACT_APP_API_URL}/${f?.path}`}
              target="_blank"
            >
              <Button
                // variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>
                        {/*  <IconButton
                          size="small"
                          disabled={f?.role_Name !== roleName}
                          onClick={() => {
                            setCurrentStateForDeleteion(f);
                            setOpenWarningBox(true);
                            //  setWarningFlag(true);
                          }}
                        >
                          <Delete
                            titleAccess="Delete"
                            color="danger"
                            fontSize="small"
                            style={{
                              color:
                                disabled || f?.role_Name !== roleName
                                  ? "gray"
                                  : "",
                            }}
                          />
                          </IconButton>*/}

                        <IconButton
                          size="small"
                          onClick={() => {
                            const allowedExtensions = [
                              ".png",
                              ".pdf",
                              ".jpg",
                              ".jpeg",
                              ".PNG",
                              ".JPG",
                              ".JPEG",
                              ".PNG",
                              ".PDF",
                            ];
                            const fileExtension = "." + ss.split(".").pop();
                            if (allowedExtensions.includes(fileExtension)) {
                              setAttachmentURL(f);
                            } else {
                              setAttachmentURL(f);

                              window.open(
                                `${process.env.REACT_APP_API_URL}/${f.path}`,
                                "_blank"
                              );
                            }
                          }}
                        >
                          <span style={{ fontSize: "12px" }}>{ss}</span>
                        </IconButton>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
          </>
        )}
      </Grid>

      {(selectedRole === "Import" ||
        selectedRole === "IR" ||
        selectedRole === "EFDV Initiator" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "HR") && (
        // selectedRole === "Logistic"
        <>
          {/* comments */}
          <Grid
            item
            xs={12}
            sm={12}
            md={selectedRole === "HR" ? 6 : 3}
            lg={selectedRole === "HR" ? 6 : 12}
          >
            <Typography style={{ marginTop: "8px", color: "black" }}>
              Comments:
              {/*  */}
            </Typography>
            <TextField
              fullWidth
              // multiline
              // rows={2}
              // maxRows={4}
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                marginTop: "8px",
              }}
              id="outlined-basic"
              variant="outlined"
              name="comments"
              value={newFormState?.comments}
              onChange={changeHandler}
            />
          </Grid>
        </>
      )}
      {selectedRole === "IR" && (
        <>
          {/* Additional comments */}
          <Grid item xs={12} sm={12} md={3} lg={12}>
            <Typography style={{ color: "black" }}>
              Additional Comments:
            </Typography>
            <TextField
              fullWidth
              multiline
              // rows={2}
              maxRows={4}
              // size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
            />
          </Grid>
        </>
      )}

      {/* //Comment history */}
      {/* {selectedRole === "IR" && (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CommentHistory
            commentsList={commentsList}
            commentsLoading={commentsLoading}
          />
        </Grid>
      )} */}
      {selectedRole === "IR" ? (
        <>
          {newFormState?.pO_No && (
            <Grid container spacing={2} style={{ marginTop: "30px" }}>
              <Grid item xs={12} sm={12} md={6} lg={12}>
                <PODetail
                  formState={newFormState}
                  setNewFormState={setNewFormState}
                />
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        ""
      )}
      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          // submit={deleteAttachmentFunc}
          submit={warningFlag ? deleteAttachmentFunc : deleteInvoice}
          message="Are you sure to delete attachment"
          deleteLoader={deleteLoader}
        />
      )}
      {alertMessage && (
        <POAlertDialog
          setAlertMessage={setAlertMessage}
          message={attachError ? attachError : docError}
          setAttachError={setAttachError}
          setDocError={setDocError}
          allow={1}
        />
      )}
    </Grid>
  );
};

export default InvoiceDetailTextField;
